
    var riot = require('riot')
    
riot.tag2('ofsted', '<div if="{!showform}" class="alert alert-info">Checklist Loading</div> <div if="{showform}"> <div class="form-horizontal"> <div class="alert alert-info"> <p>To allow us to show only neccessary items on the checklist please indicate the following:</p><br> <formselect label="Your School Type" name="type" width1="2" width2="8" onupdate="{school_type_updated}" options="{types}" value="{form_data[\'type\']}"></formselect> <formcheckbox each="{levels}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="2" width2="11" onupdate="{subupdate}"></formcheckbox> </div> <hr> <div id="checklist"> <h3>School or college contact details</h3> <formcheckbox each="{school_address}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> <h3>Admission arrangements</h3> <div if="{form_data[\'type\'] == \'maintained\'}"> <h4>Foundation schools and voluntary-aided schools</h4> <p>If the school’s governing body decides your admissions, you must publish your school’s admission arrangements each year and keep them up for the whole school year.</p> <p>You must explain:</p> <formcheckbox each="{admission_maintained}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <h4>Community schools and voluntary-controlled schools</h4> <p>If the local authority decides your admissions, write that parents should contact the local authority to find out about your admission arrangements.</p> </div> <div if="{form_data[\'type\'] == \'academy\' || form_data[\'type\'] == \'free\'}"> <p>Admissions arrangements for all mainstream academies and free schools must comply with the <a href="https://www.gov.uk/government/publications/school-admissions-code--2" target="_blank">School admissions code</a> and the <a href="https://www.gov.uk/government/publications/school-admissions-appeals-code" target="_blank">School admission appeals code.</a></p> <p>Academy trusts must publish the admissions arrangements for their schools on their website and keep them there for the whole of the offer year (the school year in which offers for places are made).</p> </div> <div if="{form_data[\'type\'] == \'academy\' || form_data[\'type\'] == \'college\'}"> <h4>16 to 19 academies and colleges</h4> <p>If you’re a 16 to 19 academy, FE college or sixth form, we recommend that you publish details of your admission arrangements.</p> <p>You should publish this information a year before the beginning of the academic year to help parents and students make an informed choice, and we recommend that the arrangements don’t change during the year. You should include details of:</p> <formcheckbox each="{admission_16_19}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox><br> <p><strong>Note:</strong> that the School admissions code and the School admissions appeal code don’t apply to 16 to 19 academies, FE colleges and sixth forms.</p> </div> <hr> <h3>Ofsted reports</h3> <p>You must publish either:</p> <formcheckbox each="{ofsted_req}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> <h3>Exam and assessment results</h3> <p>You should publish the following information on your website each year:</p> <div if="{form_data[\'levels_ks2\']}"> <h4>Key stage 2 (KS2) results</h4> <p>If you are a Key Stage 2 School, you must publish the following</p> <formcheckbox each="{assessment_ks2}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox><br> </div> <div if="{form_data[\'levels_ks4\']}"> <h4>Key stage 4 (KS4) results</h4> <p>If you are a Key Stage 4 School, you must publish the following</p> <formcheckbox each="{assessment_ks4}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox><br> </div> <div if="{form_data[\'levels_ks5\']}"> <h4>Key stage 5 (16 to 18) Information</h4> <p>If you are a Key Stage 5 School, you must publish the following</p> <formcheckbox each="{assessment_ks5}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> </div> <hr> <h3>Performance tables</h3> <formcheckbox name="performance_tables" label="You must include a link to the school and college performance tables service." value="{form_data[\'pt_performance_tables\']}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> <h3>Curriculum</h3> <p>You must publish, when applicable:</p> <formcheckbox each="{curriculum}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <div if="{form_data[\'levels_ks2\']}"> <formcheckbox each="{curriculum_ks1}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> </div> <div if="{form_data[\'levels_ks4\']}"> <formcheckbox each="{curriculum_ks4}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> </div> <div if="{form_data[\'levels_ks5\']}"> <formcheckbox each="{curriculum_ks5}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> </div> <hr> <h3>Behaviour policy</h3> <p>The policy must comply with <a href="http://www.legislation.gov.uk/ukpga/2006/40/section/89" target="_blank">Section 89 of the Education and Inspections Act 2006.</a></p> <p>Read <a href="https://www.gov.uk/government/publications/behaviour-and-discipline-in-schools" target="_blank">advice on developing and publishing your school’s behaviour policy.</a></p> <formcheckbox name="behaviour" label="You should publish details of your school’s behaviour policy" value="{form_data[\'b_behaviour\']}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> <h3>School complaints procedure</h3> <p>Read <a href="https://www.gov.uk/government/publications/school-complaints-procedures" target="_blank">guidance on developing your school’s complaints procedure.</a></p> <formcheckbox each="{complaints}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> <h3>Pupil premium</h3> <p>You must publish a strategy for the school’s use of the pupil premium. You no longer have to publish a ‘pupil premium statement’.</p> <p>For the current academic year, you must include:</p> <formcheckbox each="{pupil_prem}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <p><br>For the previous academic year, you must include:</p> <formcheckbox each="{pupil_prev}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <p><br> Pupil premium funding is allocated for each financial year, but the information you publish online should refer to the academic year, as this is how parents understand the school system.</p> <p>As you won’t know allocations for the end of the academic year (April to July), you should report on the funding up to the end of the financial year and update it when you have all the figures.</p> <p>The Teaching Schools Council has published templates to support schools in presenting their pupil premium strategies. Use of the templates is voluntary.</p> <hr> <h3>Year 7 literacy and numeracy catch-up premium</h3> <p>If your school has received year 7 literacy and numeracy catch-up premium funding, you must publish:</p> <formcheckbox each="{year7_prem}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> <h3>PE and sport premium for primary schools</h3> <p>If your school receives PE (physical education) and sport premium funding, you must publish:</p> <formcheckbox each="{pe_prem}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> <h3>Special educational needs (SEN) and disability information</h3> <p>You must publish an SEN information report on your school’s policy for pupils with SEN and should update it annually.</p> <p>You should update any changes occurring during the year as soon as possible.</p> <p>The report must comply with, Section 69 of the Children and Families Act 2014, which includes:</p> <formcheckbox each="{sen_info}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox><br> <p>You can find details on what you must include include in <ul> <li><a href="http://www.legislation.gov.uk/uksi/2014/1530/schedule/1/made" target="_blank">schedule 1 of the Special Educational Needs and Disability Regulations 2014</a></li> <li><a href="https://www.gov.uk/government/publications/send-code-of-practice-0-to-25" target="_blank">section 6 of the ‘Special educational needs and disability code of practice: 0 to 25 years’</a></li> </ul> </p> <div if="{form_data[\'type\'] == \'academy\' || form_data[\'type\'] == \'free\'}"><br> <h4>Accessibility plan for disabled pupils</h4> <p>Academies and free schools need to carry out accessibility planning for disabled pupils under the Equality Act 2010.</p> <p>You must publish your accessibility plan, which should include details of how you’re:</p> <formcheckbox each="{sen_access}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox><br> <p>The accessibility plan you publish can either be a freestanding document or part of another document (such as your school development plan).</p> </div> <hr> <h3>Equality objectives</h3> <p>Public bodies, including local-authority-maintained schools, are covered by the public sector equality duty in the Equality Act 2010.<br>This means you have to publish:</p> <formcheckbox each="{equality}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox><br> <p>Details of these publishing obligations are set out in <a href="https://www.gov.uk/government/publications/equality-act-2010-advice-for-schools" target="_blank">Equality Act 2010: advice for school</a></p> <div if="{form_data[\'type\'] == \'academy\' || form_data[\'type\'] == \'free\' || form_data[\'type\'] == \'college\'}"> <p>You need to include details of:</p> <formcheckbox each="{equality2}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> </div> <hr> <div if="{form_data[\'type\'] == \'academy\' || form_data[\'type\'] == \'free\' || form_data[\'type\'] == \'college\'}"> <h3>Complaints policy</h3> <formcheckbox each="{complaints}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> </div> <div if="{form_data[\'type\'] == \'academy\' || form_data[\'type\'] == \'free\'}"> <h3>Annual reports and accounts</h3> <p>Academies and free schools should publish the following financial information about your school:</p> <formcheckbox each="{accounts_school}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox><br> <p>You can find more guidance about these in the <a href="https://www.gov.uk/government/publications/academies-financial-handbook-2015">Academies financial handbook.</a></p> <hr> </div> <div if="{form_data[\'type\'] == \'college\'}"> <h3>Annual reports and accounts</h3> <p>FE and sixth-form colleges should publish the following financial information about your school:</p> <formcheckbox each="{accounts_college}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> </div> <h3>Governors’ information and duties</h3> <p if="{form_data[\'type\'] == \'academy\' || form_data[\'type\'] == \'free\'}">Academies and free schools should check <a href="https://www.gov.uk/government/publications/academies-financial-handbook-2015" target="_blank">Academies financial handbook</a></p> <p>This states, in the interests of transparency, an academy trust must publish on its website upto-date details of its governance arrangements in a readily accessible format. This must include: <formcheckbox each="{governors_free}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> </p> <p if="{form_data[\'type\'] == \'maintained\'}">You must publish: <formcheckbox each="{governors}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> </p> <p if="{form_data[\'type\'] == \'college\'}">You must publish: <formcheckbox each="{governors_college}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox><br> <p>You may wish to simply publish your governors’ handbook, which should include all this information.</p> </p> <hr> <h3>Charging and remissions policies</h3> <p>You must publish your school’s charging and ‘remissions’ policies (this means when you cancel fees). <br>The policies must include details of:</p> <formcheckbox each="{charging}" label="{label}" name="{name}" value="{parent.form_data[name]}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> <h3>Values and ethos</h3> <formcheckbox name="values" label="Your website should include a statement of your school’s ethos and values." value="{form_data[\'v_values\']}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr> <h3>Requests for paper copies</h3> <formcheckbox name="paper" label="If a parent requests a paper copy of the information on your school’s website, you must provide this free of charge." value="{form_data[\'p_paper\']}" width1="1" width2="11" onupdate="{subupdate}"></formcheckbox> <hr><br><br> <div class="progress_block"> <h4>Checklist Progress </h4> <progressbar max="{total}" value="{ticked}" bsstyle="success">{parent.ticked} / {parent.total}</progressbar> <button onclick="{showlogin}" if="{loggedin==false}" class="btn btn-default btn-sm pull-right">Login</button> <div if="{loggedin==true}" class="btn-toolbar pull-right"> <button onclick="{load.bind(this,true)}" class="btn btn-default btn-sm pull-right">Reload <span class="hidden-xs">Saved</span></button> <button onclick="{logout}" class="btn btn-default btn-sm pull-right">Logout</button> </div> <div class="btn-toolbar"> <confirm placement="top" onconfirm="{reset}" class="btn btn-default btn-sm">Reset <span class="hidden-xs">Checklist</span></confirm> <button onclick="{showsave}" __disabled="{saving}" class="btn btn-success btn-sm">Save <span class="hidden-xs">Checklist</span><span if="{saved}" class="fa fa-check"></span><span if="{saving}" class="fa fa-refresh fa-spin"></span></button> </div> </div><br> <modal name="loginmodal" backdrop="static" title="Login" onclose="{true}" closetext="Close" savetext="Login" onsave="{login}"> <div class="form-group"> <label>Your Email</label> <input placeholder="you@yourdomain.com" name="username" class="form-control" type="email"> </div> <div class="form-group"> <label>Password</label> <input type="password" placeholder="Your Password" name="password" class="form-control"> </div> <div if="{error}" class="alert alert-danger">{error}</div> </modal> <modal name="savechecklistmodal" backdrop="static" title="Save Your Checklist" onclose="{true}" closetext="Close"> <div class="row"> <div class="col-sm-6 col-xs-12"> <h4>Login</h4> <p>If you\'ve previously signed up, enter your login details opposite to save your checklist over the existing saved checklist in your account.</p> </div> <div class="col-sm-6 col-xs-12"> <div class="form-group"> <label>Your Email</label> <input placeholder="you@yourdomain.com" name="username" class="form-control" type="email"> </div> <div class="form-group"> <label>Password</label> <input type="password" placeholder="Your Password" name="password" class="form-control"> </div> <div onclick="{parent.login_and_save}" class="btn btn-success">Login and Save</div> </div> </div> <div if="{loginerror}" class="alert alert-danger">{loginerror}</div> <hr> <div class="row"> <div class="col-sm-6 col-xs-12"> <h4>Signup</h4> <p>Fill out your details opposite and we will save your checklist so you can come back later to complete it. Please ensure you include a valid email address as we\'ll be sending you a link which will restore this checklist.</p> </div> <div class="col-sm-6 col-xs-12"> <div class="form-group"> <label>Your School Name</label> <input type="text" placeholder="School Name" name="address" class="form-control"> </div> <div class="form-group"> <label>Your School Postcode</label> <input type="text" placeholder="School Postcode" name="postcode" class="form-control"> </div> <div class="form-group"> <label>Your First Name</label> <input type="text" placeholder="First Name" name="first_name" class="form-control"> </div> <div class="form-group"> <label>Your Surname</label> <input type="text" placeholder="Surname" name="surname" class="form-control"> </div> <div class="form-group"> <label>Your Email Address</label> <input placeholder="you@yourdomain.com" name="signup_email" class="form-control" type="email"> </div> <div class="form-group"> <label>A Password - 8 or more characters</label> <input type="password" placeholder="password" name="signup_password" class="form-control"> </div> <div onclick="{parent.signup}" class="btn btn-success">Signup and Save</div> </div> </div><br><br> <div if="{signup_error}" class="alert alert-danger">{signup_error}</div> <div if="{signup_message}" class="alert alert-success">{signup_message}</div> </modal> </div> </div> </div>', 'ofsted, [riot-tag=ofsted] { display: block; } ofsted .form-group, [riot-tag=ofsted] .form-group { margin-bottom: 5px; } ofsted .progress_block, [riot-tag=ofsted] .progress_block { position: fixed; position: sticky; bottom: 0px; left: 0; right: 0; max-width: 1140px; z-index: 2; background: #fff; -webkit-box-shadow: 0 0 5px rgba(0,0,0,0.5); box-shadow: 0 0 5px rgba(0,0,0,0.5); padding: 30px; margin: 10px auto; } @media (max-width: 767px) { ofsted .progress_block, [riot-tag=ofsted] .progress_block { padding: 10px 20px; margin: 0 5px; } }', '', function(opts) {
this.form_data = {};

this.types = [
  {
    label: "Please Select",
    value: ""
  }, {
    label: "Academy",
    value: "academy"
  }, {
    label: "College",
    value: "college"
  }, {
    label: "Free school",
    value: "free"
  }, {
    label: "Maintained",
    value: "maintained"
  }
];

this.levels = [
  {
    label: "Keystage 1/2",
    name: "levels_ks2"
  }, {
    label: "Keystage 3/4",
    name: "levels_ks4"
  }, {
    label: "Keystage 5",
    name: "levels_ks5"
  }
];

this.school_address_basic = [
  {
    label: "name of your school or college",
    name: "school_address_name"
  }, {
    label: "postal address of your school or college",
    name: "school_address_address"
  }, {
    label: "telephone number of your school or college",
    name: "school_address_phone"
  }, {
    label: "name of the member of staff who deals with queries from parents and other members of the public",
    name: "school_address_staff"
  }, {
    label: "name of the headteacher or principal",
    name: "school_address_head"
  }, {
    label: "name and address of the chair of the governing body (if you have one)",
    name: "school_address_chair"
  }, {
    label: "name and details of your special educational needs (SEN) co-ordinator (SENCO) if you’re a mainstream school or academy",
    name: "school_address_senco"
  }
];

this.admission_maintained = [
  {
    label: "how you’ll consider applications for every age group",
    name: "admission_maintained_consider"
  }, {
    label: "what parents should do if they want to apply for their child to attend your school",
    name: "admission_maintained_apply"
  }, {
    label: "your arrangements for selecting the pupils who apply (if you are a selective school)",
    name: "admission_maintained_selecting"
  }, {
    label: "your ‘over-subscription criteria’ (how you offer places if there are more applicants than places)",
    name: "admission_maintained_over-subscription"
  }
];

this.admission_16_19 = [
  {
    label: "open days your college or academy is planning",
    name: "admission_16_19_open_days"
  }, {
    label: "the process for applying for a place at your college or academy",
    name: "admission_16_19_apply"
  }, {
    label: "whether your college or academy gives priority to applications from pupils enrolled at particular schools",
    name: "admission_16_19_feeder_schools"
  }
];

this.ofsted_req = [
  {
    label: "a copy of your school’s most recent Ofsted report or a link to the report on the Ofsted website",
    name: "ofsted_req_ofsted_link"
  }
];

this.assessment_ks2 = [
  {
    label: "percentage of pupils who’ve achieved the expected standard in reading, writing and maths",
    name: "assessment_ks2_achieved"
  }, {
    label: "average progress that pupils have made in reading between KS1 and KS2",
    name: "assessment_ks2_reading_progress"
  }, {
    label: "average progress that pupils have made in writing between KS1 and KS2",
    name: "assessment_ks2_writing_progress"
  }, {
    label: "average progress that pupils have made in maths between KS1 and KS2",
    name: "assessment_ks2_maths_progress"
  }, {
    label: "percentage of pupils who’ve achieved a higher standard in reading, writing and maths",
    name: "assessment_ks2_higher"
  }, {
    label: "your pupils’ average score in the reading test",
    name: "assessment_ks2_reading_average"
  }, {
    label: "your pupils’ average score in the maths test",
    name: "assessment_ks2_maths_average"
  }
];

this.assessment_ks4 = [
  {
    label: "your school’s progress 8 score",
    name: "assessment_ks4_progress8"
  }, {
    label: "your school’s attainment 8 score",
    name: "assessment_ks4_attainment8"
  }, {
    label: "percentage of pupils who’ve achieved grade C or above in English and maths at the end of KS4 - this requirement will change from January 2018 when you must publish the percentage of pupils achieving a strong pass (grade 5 or above) in English and maths",
    name: "assessment_ks4_gradeC"
  }, {
    label: "percentage of pupils entering for the English Baccalaureate",
    name: "assessment_ks4_eng_baccalaureate"
  }, {
    label: "percentage of pupils who’ve achieved the English Baccalaureate",
    name: "assessment_ks4_eng_baccalaureate_perc"
  }, {
    label: "percentage of students staying in education or employment after key stage 4 (destinations)",
    name: "assessment_ks4_destinations"
  }
];

this.assessment_ks5 = [
  {
    label: "the progress your students have made compared with students across the country, shown separately for A levels, academic, applied general and tech level qualifications",
    name: "assessment_ks5_quals"
  }, {
    label: "the average grade your students get at KS5, shown separately for A levels, academic, applied general and tech level qualifications",
    name: "assessment_ks5_average"
  }, {
    label: "the progress your students have made in English and maths",
    name: "assessment_ks5_progress"
  }, {
    label: "retention (this is the proportion of students who get to the end of the main programme of study that they enrolled on at your institution), shown separately for each qualification type",
    name: "assessment_ks5_retention"
  }, {
    label: "destinations (this is the percentage of students who continue in education or training, or move on to employment in the year after the end of key stage 4)",
    name: "assessment_ks5_destinations"
  }
];

this.curriculum = [
  {
    label: "the content of your school curriculum in each academic year for every subject",
    name: "curriculum_content"
  }, {
    label: "your approach to the curriculum",
    name: "curriculum_approach"
  }, {
    label: "how parents or other members of the public can find out more about the curriculum your school is following",
    name: "curriculum_parents"
  }
];

this.curriculum_ks1 = [
  {
    label: "the names of any phonics or reading schemes you’re using in key stage 1",
    name: "curriculum_ks1_names"
  }
];

this.curriculum_ks4 = [
  {
    label: "a list of the courses available to pupils at key stage 4, including GCSEs",
    name: "curriculum_ks4_list"
  }
];

this.curriculum_ks5 = [
  {
    label: "how you meet the 16 to 19 study programme requirements",
    name: "curriculum_ks5_requirements"
  }, {
    label: "the 16 to 19 qualifications you offer",
    name: "curriculum_ks5_offer"
  }
];

this.complaints = [
  {
    label: "You must publish details of your school’s complaints procedure, which must comply with Section 29 of the Education Act 2002",
    name: "complaints_procedure"
  }, {
    label: "You must also publish any arrangements for handling complaints from parents of children with special educational needs (SEN) about the support the school provides.",
    name: "complaints_sen"
  }
];

this.pupil_prem = [
  {
    label: "your school’s pupil premium grant allocation amount",
    name: "pupil_prem_amount"
  }, {
    label: "a summary of the main barriers to educational achievement faced by eligible pupils at the school",
    name: "pupil_prem_barriers"
  }, {
    label: "how you’ll spend the pupil premium to overcome those barriers and the reasons for that approach",
    name: "pupil_prem_spend"
  }, {
    label: "how you’ll measure the effect of the pupil premium",
    name: "pupil_prem_measure"
  }, {
    label: "the date of the next review of the school’s pupil premium strategy",
    name: "pupil_prem_review"
  }
];

this.pupil_prev = [
  {
    label: "how you spent the pupil premium allocation",
    name: "pupil_prev_spent"
  }, {
    label: "the effect of the expenditure on eligible and other pupils",
    name: "pupil_prev_effect"
  }
];

this.year7_prem = [
  {
    label: "your funding allocation for the current academic year",
    name: "year7_prem_allocation"
  }, {
    label: "details of how you intend to spend your allocation",
    name: "year7_prem_spend"
  }, {
    label: "details of how you spent your previous year’s allocation",
    name: "year7_prem_spent"
  }, {
    label: "how last year’s allocation made a difference to the attainment of the pupils who benefit from the funding",
    name: "year7_prem_difference"
  }
];

this.pe_prem = [
  {
    label: "how much funding you received",
    name: "pe_prem_allocation"
  }, {
    label: "a full breakdown of how you’ve spent the funding or will spend the funding",
    name: "pe_prem_spent"
  }, {
    label: "the effect of the premium on pupils’ PE and sport participation and attainment",
    name: "pe_prem_difference"
  }, {
    label: "how you’ll make sure these improvements are sustainable",
    name: "pe_prem_sustainable"
  }
];

this.sen_info = [
  {
    label: "the arrangements for the admission of disabled pupils.",
    name: "sen_info_admission"
  }, {
    label: "the steps you have taken to prevent disabled pupils from being treated less favourably than other pupils.",
    name: "sen_info_treated"
  }, {
    label: "the facilities you provide to help disabled pupils to access the school.",
    name: "sen_info_access"
  }, {
    label: "the accessibility plan you have prepared in compliance with paragraph 3 of schedule 10 to the Equality Act 2010.",
    name: "sen_info_regs1"
  }, {
    label: "and Regulation 51 and schedule 1 of the Special Educational Needs and Disability Regulations 2014.",
    name: "sen_info_regs2"
  }
];

this.sen_access = [
  {
    label: "increasing your disabled pupils’ ability to participate in your school’s curriculum",
    name: "sen_access_participate"
  }, {
    label: "improving the physical environment of your school so disabled pupils can take better advantage of the education, benefits, facilities and services you offer",
    name: "sen_access_facilities"
  }, {
    label: "improving the availability of accessible information to your disabled pupils",
    name: "sen_access_availability"
  }
];

this.equality = [
  {
    label: "details of how your school is complying with the public sector equality duty - you should update this every year",
    name: "equality_details"
  }, {
    label: "your school’s equality objectives - you should update this at least once every 4 years",
    name: "equality_objectives"
  }
];

this.equality2 = [
  {
    label: "eliminating discrimination (see the Equalities Act 2010)",
    name: "equality2_eliminating"
  }, {
    label: "improving equality of opportunity for people with protected characteristics",
    name: "equality2_improving"
  }, {
    label: "consulting and involving those affected by inequality in the decisions your school or college takes to promote equality and eliminate discrimination (affected people could include parents, pupils, staff and members of the local community)",
    name: "equality2_consulting"
  }
];

this.complaints = [
  {
    label: "We recommend that all academies, free schools and colleges publish their complaints policy online.",
    name: "complaints_policy"
  }, {
    label: "If you’re an academy, free school, FE or sixth-form college, we recommend that you publish your whistleblowing policy online.",
    name: "complaints_whistleblowing"
  }, {
    label: "Academies and free schools must publish any arrangements for handling complaints from parents of children with special educational needs about the support provided by the school.",
    name: "complaints_sen"
  }
];

this.accounts_school = [
  {
    label: "annual report",
    name: "accounts_school_report"
  }, {
    label: "annual audited accounts",
    name: "accounts_school_accounts"
  }, {
    label: "memorandum of association",
    name: "accounts_school_memorandum"
  }, {
    label: "articles of association",
    name: "accounts_school_articles"
  }, {
    label: "names of charity trustees and members",
    name: "accounts_school_trustees"
  }, {
    label: "funding agreement",
    name: "accounts_school_funding"
  }
];

this.accounts_college = [
  {
    label: "Colleges should publish their instruments and articles of government on their website.",
    name: "accounts_college_articles"
  }, {
    label: "They should also publish their annual members’ report and audited financial statement every year.",
    name: "accounts_college_report"
  }
];

this.governors = [
  {
    label: "details of the structure and responsibilities of the governing body and its committees",
    name: "governors_structure"
  }, {
    label: "information about each governor’s business interests",
    name: "governors_business"
  }, {
    label: "information about each governor’s financial interests",
    name: "governors_financial"
  }, {
    label: "information about each governor’s governance roles in other schools",
    name: "governors_schools"
  }
];

this.governors_college = [
  {
    label: "the governing body’s structure and responsibilities",
    name: "governors_college_structure"
  }, {
    label: "details of any committees",
    name: "governors_college_committees"
  }, {
    label: "the names of all governors, including the chair",
    name: "governors_college_name"
  }
];

this.governors_free = [
  {
    label: "the structure and remit of the members, board of trustees, its committees and local governing bodies, and the full names of the chair of each (where applicable)",
    name: "governors_free_structure"
  }, {
    label: "for each member who has served at any point over the past 12 months, their full names, date of appointment, date they stepped down (where applicable), and relevant business and pecuniary interests including governance roles in other educational institutions",
    name: "governors_free_members"
  }, {
    label: "for each trustee and local governor who has served at any point over the past 12 months, their full names, date of appointment, term of office, date they stepped down (where applicable), who appointed them (in accordance with the trust’s articles), and relevant business and pecuniary interests including governance roles in other educational institutions",
    name: "governors_free_terms"
  }, {
    label: "for each trustee their attendance records at board and committee meetings over the last academic year for each local governor their attendance records at local governing body meetings over the last academic year",
    name: "governors_free_attendance"
  }
];

this.charging = [
  {
    label: "the activities or cases where your school will charge pupils’ parents",
    name: "charging_cases"
  }, {
    label: "the circumstances where your school will make an exception on a payment you would normally expect to receive under your charging policy",
    name: "charging_exceptions"
  }
];

this.on('mount', function() {
  var err, json;
  if (!window.location.search.match(/editmode/)) {
    this.showform = true;
  }
  json = window.localStorage.getItem("ofsted");
  if (json && json.length > 0) {
    try {
      this.form_data = JSON.parse(json);
    } catch (error) {
      err = error;
      this.form_data = {};
    }
  }
  this.load();
  this.update();
  return this.update();
});

this.on('update', function() {
  if (this.form_data["type"] === "free" || this.form_data["type"] === "academy") {
    this.school_address = this.school_address_basic.concat([
      {
        label: "if the school’s owner is an individual, you should publish their full name and contact details (address and a telephone number)",
        name: "school_address_individual_owner"
      }, {
        label: "if the school’s owner is a group or organisation, you should publish the address and telephone number of its office",
        name: "school_address_group_owner"
      }
    ]);
  } else {
    this.school_address = this.school_address_basic;
  }
  return this.calc_progress();
});

this.load = (function(_this) {
  return function(force) {
    return _this.xhr("GET", "/duocms/api/ofsted", _this.form_data, function(res) {
      if (res.status === 200) {
        _this.loggedin = true;
        if (JSON.stringify(_this.form_data).length < JSON.stringify(res.body.data).length || force) {
          _this.form_data = res.body.data;
        }
      } else {
        _this.loggedin = false;
      }
      _this.update();
      return _this.update();
    });
  };
})(this);

this.calc_progress = (function(_this) {
  return function() {
    var ticked, ticks;
    ticks = [].slice.call(_this.root.querySelectorAll("#checklist input[type=checkbox]"));
    ticked = 0;
    ticks.forEach(function(elem) {
      return elem.checked === true && ticked++;
    });
    _this.total = ticks.length;
    return _this.ticked = ticked;
  };
})(this);

this.school_type_updated = (function(_this) {
  return function(data) {
    _this.form_data["type"] = data.value;
    _this.save();
    _this.calc_progress();
    return _this.update();
  };
})(this);

this.subupdate = (function(_this) {
  return function(data) {
    _this.form_data[data.name] = data.value;
    return _this.save();
  };
})(this);

this.reset = (function(_this) {
  return function() {
    _this.form_data = {};
    _this.save();
    _this.calc_progress();
    return _this.update();
  };
})(this);

this.showsave = (function(_this) {
  return function() {
    if (_this.loggedin) {
      return _this.save_to_server();
    } else {
      return _this.tags.savechecklistmodal.show();
    }
  };
})(this);

this.showlogin = (function(_this) {
  return function() {
    return _this.tags.loginmodal.show();
  };
})(this);

this.signup = (function(_this) {
  return function() {
    var data;
    data = {
      username: _this.tags.savechecklistmodal.signup_email.value,
      password: _this.tags.savechecklistmodal.signup_password.value,
      address: _this.tags.savechecklistmodal.address.value,
      postcode: _this.tags.savechecklistmodal.postcode.value,
      first_name: _this.tags.savechecklistmodal.first_name.value,
      surname: _this.tags.savechecklistmodal.surname.value,
      ofsted: JSON.stringify(_this.form_data)
    };
    return _this.xhr("POST", "/duocms/api/ofsted/register", data, function(res) {
      var message, ref;
      if (res.status === 200) {
        message = "You should have received an email from us. Click on the link in that email to activate your account and save your checklist data.";
        return _this.tags.savechecklistmodal.update({
          signup_message: message
        });
      } else if ((ref = res.body) != null ? ref.message : void 0) {
        _this.tags.savechecklistmodal.update({
          signup_error: res.body.message
        });
        return setTimeout((function() {
          return _this.tags.savechecklistmodal.update({
            signup_error: null
          });
        }), 3000);
      } else {
        _this.tags.savechecklistmodal.update({
          signuperror: "Signup failed, please try again"
        });
        return setTimeout((function() {
          return _this.tags.savechecklistmodal.update({
            signuperror: null
          });
        }), 3000);
      }
    });
  };
})(this);

this.login_and_save = (function(_this) {
  return function() {
    var data;
    data = {
      username: _this.tags.savechecklistmodal.email.value,
      password: _this.tags.savechecklistmodal.password.value
    };
    return _this.xhr("POST", "/duocms/api/ofsted", data, function(res) {
      var ref;
      if (res.status === 200) {
        _this.tags.savechecklistmodal.hide();
        return _this.save_to_server();
      } else if ((ref = res.body) != null ? ref.message : void 0) {
        _this.tags.savechecklistmodal.update({
          loginerror: res.body.message
        });
        return setTimeout((function() {
          return _this.tags.savechecklistmodal.update({
            loginerror: null
          });
        }), 3000);
      } else {
        _this.tags.savechecklistmodal.update({
          loginerror: "Login failed, please try again"
        });
        return setTimeout((function() {
          return _this.tags.savechecklistmodal.update({
            loginerror: null
          });
        }), 3000);
      }
    });
  };
})(this);

this.save_to_server = (function(_this) {
  return function() {
    _this.saving = true;
    _this.update();
    return _this.xhr("POST", "/duocms/api/ofsted", _this.form_data, function(res) {
      _this.saving = false;
      _this.saved = true;
      _this.update();
      return setTimeout((function() {
        return _this.update({
          saved: false
        });
      }), 3000);
    });
  };
})(this);

this.logout = (function(_this) {
  return function() {
    return _this.xhr("GET", "/duocms/api/logout", null, function(res) {
      _this.loggedin = false;
      return _this.update();
    });
  };
})(this);

this.login = (function(_this) {
  return function() {
    var data;
    data = {
      username: _this.tags.loginmodal.username.value,
      password: _this.tags.loginmodal.password.value
    };
    return _this.xhr("POST", "/duocms/api/login", data, function(res) {
      var ref;
      if (res.status === 200) {
        _this.tags.loginmodal.hide();
        _this.loggedin = true;
        return _this.update();
      } else if ((ref = res.body) != null ? ref.message : void 0) {
        _this.tags.loginmodal.update({
          error: res.body.message
        });
        return setTimeout((function() {
          return _this.tags.loginmodal.update({
            error: null
          });
        }), 3000);
      } else {
        _this.tags.loginmodal.update({
          error: "Login failed, please try again"
        });
        return setTimeout((function() {
          return _this.tags.loginmodal.update({
            error: null
          });
        }), 3000);
      }
    });
  };
})(this);

this.xhr = (function(_this) {
  return function(method, url, data, cback) {
    var xhr;
    xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader("x-csrf-token", window.csrf);
    xhr.onreadystatechange = function() {
      var res;
      if (xhr.readyState === 4) {
        try {
          res = JSON.parse(xhr.responseText);
        } catch (error) {
          res = "";
        }
        return cback({
          status: xhr.status,
          body: res
        });
      }
    };
    return xhr.send(JSON.stringify(data));
  };
})(this);

this.save = (function(_this) {
  return function() {
    var json;
    json = JSON.stringify(_this.form_data, null, true);
    window.localStorage.setItem("ofsted", json);
    return _this.update();
  };
})(this);
});
    
  